import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'pageTitle'
  | 'currentURLText'
  | 'verifiedURLText'
  | 'infoText'
  | 'cancelButtonText'
  | 'continueButtonText';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  pageTitle: {
    id: 'boxFileRequest.sharedURLSpoofedPage.pageTitle',
    description: 'Page title for SharedLink spoofed page',
    defaultMessage: 'Redirecting...',
  },
  currentURLText: {
    defaultMessage: 'Current Link: {currentURL}',
    description:
      'Text telling the user the current URL in the browser address bar',
    id: 'boxFileRequest.sharedURLSpoofedPage.currentURLText',
  },
  verifiedURLText: {
    defaultMessage: 'New Link: {verifiedUrl}',
    description:
      'Text telling the user the URL of the page they are trying to open',
    id: 'boxFileRequest.sharedURLSpoofedPage.verifiedURLText',
  },
  infoText: {
    defaultMessage: `The content you are attempting to access has moved to a new location. Please click "Continue" below to view the content.`,
    description: 'Text informing user that the link has moved to a new url',
    id: 'boxFileRequest.sharedURLSpoofedPage.infoText',
  },

  cancelButtonText: {
    defaultMessage: 'Cancel',
    description: 'Label for button to cancel and go back to Box',
    id: 'boxFileRequest.sharedURLSpoofedPage.cancelButtonText',
  },
  continueButtonText: {
    defaultMessage: 'Continue',
    description: 'Label for button to continue to the link',
    id: 'boxFileRequest.sharedURLSpoofedPage.continueButtonText',
  },
});

export default messages;
